import { render } from "./view.vue?vue&type=template&id=5d4a75bf&ts=true"
import script from "./view.vue?vue&type=script&lang=ts"
export * from "./view.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Pages/Admin/Repository/view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d4a75bf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d4a75bf', __exports__)) {
    api.reload('5d4a75bf', __exports__)
  }
  
  module.hot.accept("./view.vue?vue&type=template&id=5d4a75bf&ts=true", () => {
    api.rerender('5d4a75bf', render)
  })

}


export default __exports__